import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, AbstractControl} from '@angular/forms';

@Directive({
    standalone: false,
    selector: '[mas-workinghours]',
    providers: [{ provide: NG_VALIDATORS, useExisting: WorkingHoursValidatorDirective, multi: true }]
})
export class WorkingHoursValidatorDirective implements Validator {

    validate(control: AbstractControl): ValidationErrors | null {
        return this.workingHoursValidator(control)
    }
    workingHoursValidator(control: AbstractControl<any, any>): ValidationErrors | null {
        // Had to rewrite code a bit to make it work for Angular 19
        const hoursPerWeekAdministrativeWork = +control.get('hoursPerWeekAdministrativeWork')?.value || 0;
        const hoursPerWeekManagement = +control.get('hoursPerWeekManagement')?.value || 0;
        const hoursPerWeekCommercial = +control.get('hoursPerWeekCommercial')?.value || 0;
        const hoursPerWeekManualLabour = +control.get('hoursPerWeekManualLabour')?.value || 0;
        const totalHours =
            hoursPerWeekAdministrativeWork +
            hoursPerWeekManagement +
            hoursPerWeekCommercial +
            hoursPerWeekManualLabour;
        const returnValue = totalHours > 60 ? { 'tooManyWorkingHours': true } : null;
        return returnValue;
    }
}
